import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>KSE Solutions</h3>
            <p>Ihr Partner für erfolgreiche Projekte</p>
          </div>
          
          <div class="footer-section">
            <h4>Kernkompetenzen</h4>
            <ul>
              <li><a routerLink="/netzbau">Netzbau</a></li>
              <li><a routerLink="/systemtechnik">Systemtechnik</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Unternehmen</h4>
            <ul>
              <li><a routerLink="/ueber-uns">Über uns</a></li>
              <li><a routerLink="/kontakt">Kontakt</a></li>
              <li><a routerLink="/datenschutz" rel="noopener noreferrer">Datenschutzerklärung</a></li>
              <li><a routerLink="/impressum" rel="noopener noreferrer">Impressum</a></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Kontakt</h4>
            <p>KSE Solutions GmbH<br>
               Schweiz<br>
               <a href="tel:+41762284520">+41 (0)76 288 45 20</a><br>
               <a href="tel:+41762880198">+41 (0)76 288 01 98</a><br>
               <a href="mailto:info&#64;kse-solutions.ch">info&#64;kse-solutions.ch</a>
            </p>
          </div>
        </div>
        
        <div class="footer-bottom">
          <p>&copy; 2025 KSE Solutions GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .footer {
      background-color: #001635;
      color: white;
      margin-top: clamp(3rem, 6vw, 5rem);
      position: relative;
      overflow: hidden;
    }

    .footer::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
      opacity: 0.5;
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: clamp(2rem, 5vw, 3rem) clamp(1rem, 4vw, 2rem) clamp(1rem, 2vw, 1.5rem);
      position: relative;
      z-index: 1;
    }

    .footer-content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
      gap: clamp(1.5rem, 4vw, 2.5rem);
      margin-bottom: clamp(1.5rem, 3vw, 2rem);
    }

    .footer-section h3 {
      color: #00a1f3;
      margin-bottom: clamp(0.75rem, 2vw, 1rem);
      font-size: clamp(1.1rem, 2.5vw, 1.4rem);
      letter-spacing: -0.025em;
      font-weight: 700;
    }

    .footer-section h4 {
      margin-bottom: clamp(0.75rem, 2vw, 1rem);
      font-size: clamp(1rem, 2vw, 1.2rem);
      font-weight: 600;
      color: #ffffff;
    }

    .footer-section ul {
      list-style: none;
      padding: 0;
    }

    .footer-section ul li {
      margin-bottom: clamp(0.4rem, 1vw, 0.6rem);
    }

    .footer-section a {
      color: #ccc;
      text-decoration: none;
      transition: color 0.3s ease;
      font-size: clamp(0.9rem, 2vw, 1rem);
      position: relative;
    }

    .footer-section a::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 0;
      height: 1px;
      background-color: #00a1f3;
      transition: width 0.3s ease;
    }

    .footer-section a:hover {
      color: #00a1f3;
    }

    .footer-section a:hover::after {
      width: 100%;
    }

    .footer-section p {
      font-size: clamp(0.9rem, 2vw, 1rem);
      line-height: 1.6;
      color: #ccc;
    }

    .footer-bottom {
      border-top: 1px solid #003366;
      padding-top: clamp(0.75rem, 2vw, 1rem);
      text-align: center;
      color: #ccc;
      font-size: clamp(0.85rem, 1.8vw, 0.95rem);
    }

    @media (max-width: 1200px) {
      .footer-content {
        grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
        gap: clamp(1.25rem, 3vw, 2rem);
      }
    }

    @media (max-width: 992px) {
      .footer-content {
        grid-template-columns: repeat(2, 1fr);
        gap: clamp(1rem, 2.5vw, 1.75rem);
      }
    }

    @media (max-width: 768px) {
      .footer-content {
        grid-template-columns: 1fr;
        gap: clamp(1.25rem, 3vw, 1.75rem);
      }
      
      .container {
        padding: clamp(1.5rem, 4vw, 2.5rem) clamp(0.75rem, 2vw, 1.25rem) clamp(0.75rem, 2vw, 1.25rem);
      }
    }

    @media (max-width: 480px) {
      .container {
        padding: 2rem 1rem 1rem;
      }

      .footer-section {
        text-align: center;
      }
      
      .footer-section h3,
      .footer-section h4 {
        margin-bottom: clamp(0.5rem, 1.5vw, 0.75rem);
      }
      
      .footer-section ul li {
        margin-bottom: clamp(0.3rem, 1vw, 0.5rem);
      }
    }

    @media (max-width: 360px) {
      .container {
        padding: 1.5rem 0.75rem 0.75rem;
      }
      
      .footer-section h3 {
        font-size: 1.1rem;
      }
      
      .footer-section h4 {
        font-size: 0.95rem;
      }
      
      .footer-section a,
      .footer-section p {
        font-size: 0.85rem;
      }
    }

    /* Touch device optimizations */
    @media (hover: none) and (pointer: coarse) {
      .footer-section a {
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  `]
})
export class FooterComponent {}
